import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Hammer, RefreshCw, CheckCircle2 } from "lucide-react";
import { api } from "../lib/api.js";

const SHORT = {
  PENDING: "Pendente", SCHEDULE: "Agendado", "BPS 0 - RECEIVE": "0 Recepção",
  "BPS 1 - BATECHAPAS": "1 Chapa", "BPS 2 - PREPARAÇÃO": "2 Prep.",
  "BPS 3 - PINTURA": "3 Pintura", "BPS 4 - ACABAMENTO": "4 Acabam.",
  "EM LAVAGEM": "Lavagem", RESOLVED: "Resolvido",
};

const PRIORITY_STYLE = {
  Alta: "border-l-[#DC3545]", Normal: "border-l-[#1F3864]", Baixa: "border-l-[#6C757D]",
};

export default function BodyShopBoardPage() {
  const [buckets, setBuckets] = useState({});
  const [order, setOrder] = useState([]);
  const [refreshKey, setRefreshKey] = useState(0);

  const load = async () => {
    const { data } = await api.get("/body-shop-cases/board/state");
    setBuckets(data.buckets);
    setOrder(data.state_order);
  };
  useEffect(() => { load(); }, [refreshKey]);

  return (
    <div className="p-4 sm:p-6 max-w-full">
      <div className="flex items-end justify-between mb-4">
        <div>
          <h1 className="font-heading text-2xl font-bold text-[#1A1A2E] flex items-center gap-2">
            <Hammer className="w-6 h-6 text-[#1F3864]" /> Progress Board — Bate-chapas
          </h1>
          <p className="text-sm text-[#6C757D] mt-1">Vista Kanban-light das viaturas em processo. Clica num cartão para abrir o caso.</p>
        </div>
        <div className="flex gap-2">
          <Link to="/body-shop-cases" className="text-xs border border-gray-300 hover:border-[#1F3864] rounded-sm px-3 py-1.5">Vista tabela</Link>
          <button onClick={() => setRefreshKey((k) => k + 1)} className="text-xs border border-gray-300 hover:border-[#1F3864] rounded-sm px-3 py-1.5 flex items-center gap-1" data-testid="bps-board-refresh">
            <RefreshCw className="w-3 h-3" /> Atualizar
          </button>
        </div>
      </div>

      <div className="overflow-x-auto pb-4">
        <div className="flex gap-3 min-w-max">
          {order.map((state) => {
            const items = buckets[state] || [];
            return (
              <div key={state} className="w-72 flex-shrink-0" data-testid={`bps-board-col-${state}`}>
                <div className="bg-[#F4F6F8] border border-gray-200 rounded-sm px-3 py-2 flex items-center justify-between">
                  <span className="font-heading text-xs font-bold text-[#1A1A2E] uppercase tracking-widest">{SHORT[state] || state}</span>
                  <span className="text-[11px] font-mono bg-white border border-gray-300 rounded-sm px-1.5 py-0.5 text-[#6C757D]">{items.length}</span>
                </div>
                <div className="mt-2 space-y-2 min-h-[200px]">
                  {items.map((it) => (
                    <Link
                      key={it.id}
                      to={`/body-shop-cases/${it.id}`}
                      className={`block bg-white border border-gray-200 border-l-4 ${PRIORITY_STYLE[it.priority] || "border-l-[#1F3864]"} rounded-sm p-2 hover:shadow transition`}
                      data-testid={`bps-board-card-${it.number}`}
                    >
                      <div className="flex items-center justify-between gap-2">
                        <span className="font-mono text-[#1F3864] font-semibold text-sm">{it.number}</span>
                        {it.qc_passed && <CheckCircle2 className="w-3.5 h-3.5 text-emerald-600" title="QC aprovado" />}
                      </div>
                      <div className="font-mono text-xs mt-1 text-[#1A1A2E]">{it.vehicle_registration}</div>
                      <div className="text-xs text-[#6C757D] mt-0.5 truncate">{it.brand} {it.model}</div>
                      <div className="text-[11px] text-[#6C757D] mt-1 truncate" title={it.customer_name}>{it.customer_name}</div>
                      <div className="flex gap-1 flex-wrap mt-2">
                        {it.branch && <span className="text-[9px] uppercase tracking-widest bg-[#F4F6F8] border border-gray-200 rounded-sm px-1.5 py-0.5">{it.branch}</span>}
                        {it.insurance_company && <span className="text-[9px] uppercase tracking-widest bg-[#F4F6F8] border border-gray-200 rounded-sm px-1.5 py-0.5">{it.insurance_company}</span>}
                        {it.insurance_rejected && <span className="text-[9px] uppercase tracking-widest bg-[#F8D7DA] text-[#721C24] border border-[#DC3545]/30 rounded-sm px-1.5 py-0.5">rejeitada</span>}
                      </div>
                    </Link>
                  ))}
                  {items.length === 0 && <div className="text-xs text-[#6C757D] italic text-center py-6">—</div>}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
